<template>
  <div class="">
    <el-dialog :before-close="close" :visible.sync="visible" :title="`VAC查询封禁`" :width="facility == 'pc' ? '1200px' : '90%'" top="10vh" append-to-body center>
      <div class="vac">
        <div v-if="Object.keys(accountInfo).length" class="vac-info">
          <div class="vac-info-title">账户基本信息</div>
          <div class="vac-info-box">
            <div class="vac-info-list">
              <div class="vac-info-item">
                <div class="vac-info-label">头像</div>
                <div class="vac-info-value">
                  <el-image class="image" :src="accountInfo.avatarfull" alt="" fit="cover"></el-image>
                </div>
              </div>
              <div class="vac-info-item">
                <div class="vac-info-label">昵称</div>
                <div class="vac-info-value">{{ accountInfo.personaname || "" }}</div>
              </div>
              <div class="vac-info-item">
                <div class="vac-info-label">VAC封禁状态</div>
                <div :class="{ colordf0000: accountInfo.VACBanned }" class="vac-info-value">{{ accountInfo.VACBanned ? "已封禁" : "未封禁" }}</div>
              </div>
              <div class="vac-info-item">
                <div class="vac-info-label">VAC封禁数量</div>
                <div :class="{ colordf0000: accountInfo.NumberOfVACBans }" class="vac-info-value">{{ accountInfo.NumberOfVACBans || 0 }}</div>
              </div>
              <div class="vac-info-item">
                <div class="vac-info-label">游戏封禁</div>
                <div :class="{ colordf0000: accountInfo.NumberOfGameBans }" class="vac-info-value">{{ accountInfo.NumberOfGameBans || 0 }}</div>
              </div>
              <div class="vac-info-item">
                <div class="vac-info-label">封禁时间</div>
                <div :class="{ colordf0000: accountInfo.DaysSinceLastBan }" class="vac-info-value">{{ accountInfo.DaysSinceLastBan ? '封禁于' + accountInfo.DaysSinceLastBan + '天前' : 0 }}</div>
              </div>
              <div class="vac-info-item">
                <div class="vac-info-label">社区封禁</div>
                <div :class="{ colordf0000: accountInfo.CommunityBanned }" class="vac-info-value">{{ accountInfo.CommunityBanned ? "已封禁" : "未封禁" }}</div>
              </div>
              <div class="vac-info-item">
                <div class="vac-info-label">注册时间</div>
                <div class="vac-info-value">{{ accountInfo.timecreated || "" }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="gameList.length" class="vac-game">
          <div class="vac-game-title">库存游戏列表</div>
          <div class="vac-game-box">
            <div class="vac-game-list">
              <div v-for="(item, index) in gameList" :key="index" class="vac-game-item">
                <el-image class="image" :src="item.header_url" alt="" fit="cover"></el-image>
                <div class="name">{{ item.name || "" }}</div>
                <div class="time">总时数：{{ item.playtime_forever ? (item.playtime_forever / 60).toFixed(2) + "小时" : "无" }}</div>
                <div class="time">过去2周游玩时间：{{ item.playtime_2weeks ? (item.playtime_2weeks / 60).toFixed(2) + "小时" : "无" }}</div>
                <div v-if="item.rtime_last_played" class="time">最后运行日期：{{ item.rtime_last_played ? conversionTime(item.rtime_last_played) : 0 }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { parseTime } from "@/utils/date.js";

import { mapState } from "vuex";

export default {
  name: "vacDialog",
  props: {
    // 显示
    visible: {
      type: Boolean,
      default: false
    },
    // 
    accountInfo: {
      type: Object,
      default () {
        return {}
      }
    },
    // 
    gameList: {
      type: Array,
      default () {
        return []
      },
    }
  },
  data () {
    return {
      facility: sessionStorage.getItem("facility")
    };
  },
  computed: {
    ...mapState(["token"])
  },
  methods: {
    // 转换时间
    conversionTime (data) {
      return parseTime(data).split(" ")?.[0];
    },
    // 关闭
    close () {
      this.$emit("cancel");
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/vac/index.scss";

::v-deep .el-dialog {
  background: url("@/assets/img/vac.png") #171616;
  background-repeat: no-repeat;
  background-size: 100%;

  .el-dialog__title {
    color: #fff;
  }
}

.vac {
  max-height: 75vh;
  padding-right: 10px;
  overflow-y: scroll;

  &-info {
    margin: 0 auto 60px;
  }
}

@media only screen and (min-width: 901px) {
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-track {
    background-color: rgba($color: #000, $alpha: .2);
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
    cursor: pointer;
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgba($color: #000, $alpha: .1);
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
    cursor: pointer;
  }
}
</style>
